import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-74">
      {/* Bold red gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-red via-[#d92a38] to-[#b31b27] z-0" data-id="element-75"></div>

      {/* Decorative circles */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-white/10 rounded-full blur-3xl z-0" data-id="element-76"></div>
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-black/10 rounded-full blur-3xl z-0" data-id="element-77"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-79">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight" data-id="element-80">
            Ready to Explore DC?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto font-medium" data-id="element-81">
            Get your mobility equipment delivered today. Best rates guaranteed.
            Experience the city without limits.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-82">
            <a href="#reserve" className="w-full sm:w-auto px-8 py-4 bg-white text-brand-red rounded-full font-bold text-lg hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2 group" data-id="element-83">
              Reserve Online
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-84" />
            </a>
            <a href="tel:+18003954459" className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white text-white rounded-full font-bold text-lg hover:bg-white/10 transition-all flex items-center justify-center gap-2" data-id="element-85">
              <PhoneIcon className="w-5 h-5" data-id="element-86" />
              Call (800) 395-4459
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}